import requests from "./httpServices";


export const uploadVirtualBackground = (file) => {
  const formData = new FormData();
  formData.append("background", file);
  
  return requests.post("/virtual-backgrounds/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export const getUserVirtualBackgrounds = () => {
  return requests.get("/virtual-backgrounds");
};


export const deleteVirtualBackground = (id) => {
  return requests.delete(`/virtual-backgrounds/${id}`);
};

